import React from "react";
import styles from "./index.module.scss";
import { SubscriptionHistoryType } from "../../../common/types/subscription.types";
import UserSection from "./sections/user.section";
import DateSection from "./sections/date.section";
import TextSection from "./sections/text.section";
import SubscriptionSection from "./sections/subscription.section";
import cn from "../../../Utils/class-names.utils";
import UserIcon from "../../icons/subscription-status/user.icon";
import SuccessIcon from "../../icons/subscription-status/success.icon";
import BaseSpam2Icon from "../../icons/subscription-status/base-spam-2.icon";
import StarIcon from "../../icons/subscription-status/star.icon";
import { historyEvents } from "./mock.data";

const HistoryDetails = {
  [SubscriptionHistoryType.TrialStarted]: {
    title: "Trial Started",
    component: DateSection,
    iconBgColorClass: styles.iconBackgroundBlue,
    icon: SuccessIcon
  },
  [SubscriptionHistoryType.AccountCreated]: {
    title: "Account Created",
    component: UserSection,
    iconBgColorClass: styles.iconBackgroundPurple,
    icon: UserIcon
  },
  [SubscriptionHistoryType.TrialExtended]: {
    title: "Trial Extended",
    component: DateSection,
    iconBgColorClass: styles.iconBackgroundBlue,
    icon: SuccessIcon
  },
  [SubscriptionHistoryType.ExtendTimeRequest]: {
    title: "Extend Time Request",
    component: DateSection,
    iconBgColorClass: styles.iconBackgroundBlue,
    icon: SuccessIcon
  },
  [SubscriptionHistoryType.TimeApproved]: {
    title: "Time Approved",
    component: DateSection,
    iconBgColorClass: styles.iconBackgroundBlue,
    icon: SuccessIcon
  },
  [SubscriptionHistoryType.AccountSuspended]: {
    title: "Account Suspended",
    component: TextSection,
    iconBgColorClass: styles.iconBackgroundGrey,
    icon: BaseSpam2Icon
  },
  [SubscriptionHistoryType.ConvertedSubscription]: {
    title: "Converted to Subscription",
    component: SubscriptionSection,
    iconBgColorClass: styles.iconBackgroundGreen,
    icon: StarIcon
  },
  [SubscriptionHistoryType.SubscriptionChanged]: {
    title: "Subscription Changed",
    component: SubscriptionSection,
    iconBgColorClass: styles.iconBackgroundBlue,
    icon: StarIcon
  },
}

interface AccountHistoryProps {
  onViewDetails?: () => void;
  isDistributorView?: boolean;
}

const AccountHistory = ({ onViewDetails, isDistributorView = false }: AccountHistoryProps) => {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h2 className={styles.title}>
          Account History
        </h2>
      </header>

      <div className={styles.eventsContainer}>
        {historyEvents.map((event, index) => {
          const historyDetail = HistoryDetails[event.type];
          const HistoryComponent = historyDetail?.component;
          const iconBgColorClass = historyDetail?.iconBgColorClass;
          const Icon = historyDetail?.icon;
          return (
            <article
              key={event.id}
              className={styles.event}
            >
              <div className={styles.iconContainer}>
                <div className={cn(styles.iconBackground, iconBgColorClass)}>
                  <Icon />
                </div>

                <div className={styles.verticalLine} />
              </div>

              <div className={styles.eventContent}>
                <div className={styles.eventDetails}>
                  <h3 className={styles.eventTitle}>
                    {HistoryDetails[event.type]?.title || ""}
                  </h3>

                  <div className={styles.detailsContainer}>
                    <HistoryComponent 
                      {...event.details} 
                      showButton={event.type === SubscriptionHistoryType.ExtendTimeRequest && !isDistributorView}
                      onViewDetails={onViewDetails}
                    />
                  </div>
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </div>
  );
};

export default AccountHistory;
